import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "item", "range", "applyButton"]
  static values = {
    confirmMessage: String,
    emptyRange: { type: String, default: "-" }
  }

  connect() {
    if (this.hasSourceTarget && !this.sourceTarget.value) {
      this.sourceTarget.value = this.sortedDates().slice(-1)[0] || ""
    }

    this.refreshRange()
    this.refreshApplyButton()
  }

  synchronize(event) {
    event.preventDefault()

    const date = this.hasSourceTarget ? this.sourceTarget.value : ""
    if (!date) {
      if (this.hasSourceTarget) this.sourceTarget.focus()
      this.refreshApplyButton()
      return
    }

    const formattedDate = this.formatDate(date)
    const message = `${this.confirmMessageValue} (${formattedDate})`
    if (!window.confirm(message)) return

    this.itemTargets.forEach((input) => {
      input.value = date
      input.dispatchEvent(new Event("input", { bubbles: true }))
      input.dispatchEvent(new Event("change", { bubbles: true }))
    })

    this.refreshRange()
  }

  refreshApplyButton() {
    if (!this.hasApplyButtonTarget) return

    this.applyButtonTarget.disabled = !this.hasSourceTarget || !this.sourceTarget.value
  }

  refreshRange() {
    if (!this.hasRangeTarget) return

    const dates = this.sortedDates()
    if (dates.length === 0) {
      this.rangeTarget.textContent = this.emptyRangeValue
    } else if (dates[0] === dates[dates.length - 1]) {
      this.rangeTarget.textContent = this.formatDate(dates[0])
    } else {
      this.rangeTarget.textContent = `${this.formatDate(dates[0])} – ${this.formatDate(dates[dates.length - 1])}`
    }
  }

  sortedDates() {
    return this.itemTargets
      .map((input) => input.value)
      .filter((value) => value)
      .sort()
  }

  formatDate(value) {
    const [year, month, day] = value.split("-").map(Number)
    return new Intl.DateTimeFormat(document.documentElement.lang || "de-DE").format(new Date(year, month - 1, day))
  }
}
